import get from "lodash/get";
import { useState } from "react";

import { useSetLocationData } from "~/hooks/locationData";
import { SRR_REPORTS_CONFIG } from "~/pages/SRR/model/reportsConfig";

const REFETCH_CHAIN_ORDER = [
  "ReportReturnLoyaltyServiceByDealer",
  "ReportReturnLoyaltyService",
  "ReportReturnUniqueService",
  "TOMonthOfControlMine",
  "TOMonthOfControlFriendOrFoe",
  "TOMonthOfControlFriendOrFoeByCarFamily",
  "TOMonthOfControlCarFamilyRegion",
  "TOOwnBySalesPeriod",
  "TOFriendOrFoeBySalesPeriod",
  "warrantyRepairMonthOfControl",
  "warrantyRepairBySalesPeriod",
  "ReportReturnCarServiceDynamics",
  "ReportReturnCarServiceByDealer",
  "ReportReturnCarAverageDailyMileageByMonth",
  "ReportReturnClientsWithoutService",
  "ReportReturnSRR3ByDealer",
  "ReportReturnSRR3ByPeriod",
  "ReportReturnSRR3ForPayments",
  "ReportReturnSRR3ByCar",
  "ReportReturnSRR3ByVIN",
  "ReportReturnSRR5ByVIN",
  "ReportReturnSRR5ByDealer",
  "ReportReturnSRR5ByPeriod",
  "ReportReturnSRR5ForPayments",
  "ReportReturnSRR5ByCar",
  "ReportReturnCarForServiceGIBDDByPeriod",
  "ReportReturnCarForServiceGIBDDByMonth",
  "ReportReturnCarForeignForServiceGIBDDByMonth",
  "ReportReturnCarForeignForServiceGIBDDByPeriod",
  "ReportReturnSRR3GIBDDByDealer",
  "ReportReturnSRR5GIBDDByDealer",
  "ReportReturnSRR3GIBDDByPeriod",
  "ReportReturnSRR5GIBDDByPeriod",
  "TOReturnCarForServiceByPeriodConsolidated",
  "TOFriendOrFoeByPeriodByCarFamily",
  "ReportNSByDealer",
  "ReportNSByConsultant",
  "ReportNSByClient",
  "ReportNSByWarmClients",
  "ReportNSByOldClients",
  "ReportNSByAverageCarAge",
  "ReportNSByClientCarSale",
  "InvitationOfClientsForMaintenance",
  "ReportReturnAverageReceiptAKC",
  "ReportAverageReceiptTO",
];

const requestTable = () => {
  const [tableReport, setTableReport] = useState({});
  const setData = useSetLocationData();
  const clearTableReport = () => {
    if (Object.keys(tableReport).length > 0) setTableReport({});
  };

  const queries: Record<string, [(opts?: any) => void, any]> = {};

  for (const [key, cfg] of Object.entries(SRR_REPORTS_CONFIG)) {
    const { hook, getterPath, defaultArray } = cfg.table;
    queries[key] = hook({
      onCompleted(data: unknown) {
        setTableReport(get(data, getterPath, defaultArray ? [] : {}));
        setData("openModal", "");
      },
      fetchPolicy: "no-cache",
    });
  }

  const loading = Object.values(queries).some(([, result]) => result.loading);

  const refetch = REFETCH_CHAIN_ORDER.map(
    (key) => queries[key]?.[1]?.refetch,
  ).find(Boolean);

  const dataReport = (name: string) => queries[name]?.[0];

  return { tableReport, dataReport, loading, clearTableReport, refetch };
};

export default requestTable;
